import { Track } from './Track';
import router from '@/router';
import pkg from '../../package.json';
export function registerPulgs(Vue) {
  // 数据埋点
  Vue.use(Track, {
    router,
    env: window.appConfig.VUE_APP_ENV ? 'test' : 'prod',
    // 每个接口都需携带的公共字段
    commonFields: {
      apply_name: process.env.VUE_APP_TITLE,
      platform_type: '新官网',
      apply_version: pkg.version,
      execution_environment: `qbq${window.appConfig.VUE_APP_ENV || 'prod'}`, // qbqdev qqdevelop qbqstandard qbqprod
    },
    trackOptions: {
      is_track_single_page: true,
      show_log: window.appConfig.VUE_APP_ENV === 'dev',
      heatmap: {
        clickmap: 'default',
        scroll_notice_map: 'default',
      },
    },
  });
}
